import UserLayout from '@/pages/user/layout'
import UserIndexPage from '@/pages/user/index'
import UserViewPage from '@/pages/user/view'
import UserCreatePage from '@/pages/user/create'
import UserUpdatePage from '@/pages/user/update'

var routes = {
	path: '/users',
	component: UserLayout,
	meta: {title: 'Сотрудники', breadcrumb: 'Сотрудники'},
	children: [
		{
			path: 'settings',
			component: () => import('@/pages/user/settings/account'),
			children: []
		}, {
			path: '',
			component: UserIndexPage,
			meta: {title: 'Сотрудники'}
		}, {
			path: 'create',
			component: UserCreatePage,
			meta: {title: 'Новый сотрудник'}
		}, {
			path: ':id',
			component: UserViewPage,
			meta: {title: 'Профиль пользователя'},
			children: []
		}, {
			path: ':id/update',
			component: UserUpdatePage,
			meta: {title: 'Редактирование сотрудника'}
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/user.js